import { IContactCategory } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		name?: string
		note?: string
	}
}

export async function contactCategoryUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/contact/category/update/v1"
	const requester = new ApiRequester<RequestDataShape, IContactCategory>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
